module.exports = __webpack_public_path__ + "static/teleworker-career-satisfaction-40670f125c0133bcb4ccd4ad3277c47a.png";